import React from 'react';

import {CommitData} from '../../../../../providers/version';
import {EditorFooter} from '../../../common/editor-footer';
import {GlobalVersionData} from '../../../../../hooks/global-version/use-global-version-query';
import {DocFooterSkeleton} from './doc-footer-info/footer-info-skeleton';
import {DocFooterInfo} from './doc-footer-info/doc-footer-info';

interface Props {
    isLoading: boolean;
    documentId: string;
    documentRevision?: string;
    revisionInfo?: CommitData;
    selectedGlobalVersion: GlobalVersionData;
}

export function EditorFooterViewMode(props: Props) {
    if (props.isLoading) {
        return (
            <EditorFooter>
                <DocFooterSkeleton />
            </EditorFooter>
        );
    }

    if (props.revisionInfo) {
        return (
            <EditorFooter>
                <DocFooterInfo
                    documentId={props.documentId}
                    documentRevision={props.documentRevision}
                    revisionInfo={props.revisionInfo}
                    selectedGlobalVersion={props.selectedGlobalVersion}
                />
            </EditorFooter>
        );
    }

    return <EditorFooter />;
}
